import { observer } from 'mobx-react'
import React, { Fragment, useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useForm, UseFormReturn } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { McPageAlert } from 'src/Components'
import BreadCrumbs from 'src/Components/Authenticated/BreadCrumbs'
import Portlet from 'src/Components/Authenticated/Portlet'
import McButton from 'src/Components/McButton'
import { MainPage, MyDropzone } from 'src/Components/My'
import { ReadFileContent } from 'src/Helpers/FileHelper'
import { t } from 'src/I18n'
import { fileInsertStore, IFormValues } from './Store'

const Insert: React.FC = () => {
  const navigate = useNavigate()
  useEffect(() => {
    fileInsertStore.Initialize()
  }, [null])

  const { ViewModel, IsLoading, IsSubmitting, PageAlert } = fileInsertStore

  const useFormProps: UseFormReturn<IFormValues> = useForm<IFormValues>({})
  const { handleSubmit, setValue } = useFormProps

  const onSubmit = (data: IFormValues) => {
    fileInsertStore.Insert(data, navigate)
  }

  return (
    <MainPage>
      <br className="xs-10" />

      {!IsLoading && ViewModel !== undefined && (
        <Fragment>
          <BreadCrumbs currentPageTitle={t.fileInsert.title} />
          <form className="parsley-form" onSubmit={handleSubmit(onSubmit)}>
            <Portlet title={t.common.file}>
              <Row>
                <Col md={6}>
                  <MyDropzone
                    formObject={{} as IFormValues}
                    useFormProps={useFormProps}
                    name="File"
                    label={t.fileInsert.form.dataField.label}
                    //infoText={t.automaticChargeInsert.fields.SepaFileData.info}
                    dropFileText={t.fileInsert.form.dataField.dropfile}
                    rules={{
                      required: t.fileInsert.form.dataField.error.required,
                    }}
                    accept={['image/jpeg', 'image/png', 'application/pdf']}
                    onChangeFile={(files: File[] | null) => {
                      if (files === null) {
                        //removed
                        setValue('Data', '')
                        setValue('MimeType', '')
                        setValue('Name', '')
                      } else {
                        ReadFileContent(files, (base64, file) => {
                          setValue('Data', base64)
                          setValue('MimeType', file.type)
                          setValue('Name', file.name)
                        })
                      }
                    }}
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                <Col mdOffset={8} md={4}>
                  <McButton
                    block
                    bsStyle="primary"
                    type="submit"
                    isLoading={IsSubmitting}
                  >
                    {t.common.save}
                  </McButton>
                </Col>
              </Row>
            </Portlet>
          </form>
        </Fragment>
      )}

      <McPageAlert pageAlert={PageAlert} />
    </MainPage>
  )
}

export default observer(Insert)
